module.exports = __webpack_public_path__ + "img/16_001.edac7cdd.webp";